import {
  REGISTER_USER,
  REGISTER_USER_SUCCESSFUL,
  REGISTER_USER_FAILED,
  GET_KYC, GET_KYC_SUCCESSFULL, GET_KYC_FAILED,
  GET_KYC_STATUS, GET_KYC_STATUS_SUCCESSFULL, GET_KYC_STATUS_FAILED,
  GET_PROFILE,GET_PROFILE_SUCCESSFUL,
  GET_PROFILE_FAILED
} from "./actionTypes"


const { data, ...authUser } = JSON.parse(
  localStorage.getItem("authUser") || "{}",
)


const initialState = {
  registrationError: null,
  message: null,
  loading: false,
  user: data || {},
  authToken: data?.Token || null,
  userProfile:  {},

  
}
 /**
      * Used for handling auth response
      */

const account = (state = initialState, action) => {


  switch (action.type) {
    case REGISTER_USER:
      return {
        ...state,
        user: null,
        loading: true,
        registrationError: null,
      }

    case REGISTER_USER_SUCCESSFUL:
      return {
        ...state,
        loading: false,
        user: action.payload.data,
        registrationError: null,
        authToken: action.payload.data.Token,

      }
      

    case REGISTER_USER_FAILED:
      return {
        ...state,
        user: null,
        loading: false,
        registrationError: action.payload,
        authToken: null,

      }


    case GET_KYC:
      return {
        ...state,
        user: null,
        loading: true,
      }

    case GET_KYC_SUCCESSFULL:

      return {
        ...state,
        user: action.payload.data,
        loading: false,
      }

    case GET_KYC_FAILED:
      return {
        ...state,
        user: null,
        loading: false,
      }

    case GET_KYC_STATUS:
      return {
        ...state,
        user: null,
        loading: true,
      }

    case GET_KYC_STATUS_SUCCESSFULL:
      return {
        ...state,
        user: action.payload.data,
        loading: false,
      }

    case GET_KYC_STATUS_FAILED:
      return {
        ...state,
        user: null,
        loading: false,
      }


      case GET_PROFILE:
        return {
          ...state,
          userProfile: null,
          loading: true,
        }
  
      case GET_PROFILE_SUCCESSFUL:
        return {
          ...state,
          userProfile: action.payload.data,
          loading: false,
        }
  
      case GET_PROFILE_FAILED:
        return {
          ...state,
          userProfile: null,
          loading: false,
        }
  
    default:
      return state
  }
}

export default account
